<template>
    <div v-if="sitemapContent" :class="{ notShow: !sitemapContent }">
        <div v-html="sitemapContent"></div>
    </div>
    <div style="border: none; background-color: #0d3c61; color: #eee">
        <div class="footer-content">
            <div class="layout-footer" style="border: none; background-color: #0d3c61; color: #eee" >
                <div>
                    <p>Copyright &copy; {{ thisYear }}, all rights reserved.</p>
                    <p>{{ siteName }}</p>
                </div>
                <div class="footer-icons">
                    <button class="p-link" @click="gotoTerms()">
                        <em class="pi pi-shield" style="color: #eee"></em>
                    </button>
                    <button class="p-link" @click="gotoPrivacy()">
                        <em class="pi pi-info-circle" style="color: #eee"></em>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    data() {
        return {
            thisYear: null,
            siteName: process.env.VUE_APP_SYSTEM_NAME,
            sitemapContent: '',
        };
    },
    created() {
        let d = new Date();
        let n = d.getFullYear();
        this.thisYear = n + '';
    },
    mounted() {
        this.loadSiteMapContent();
    },
    methods: {
        loadSiteMapContent() {
            let contentFolder = process.env.VUE_APP_EXPLORE_CONTENT_FOLDER;
            this.$fetchExternalContent(process.env.VUE_APP_EXPLORE_CONTENT_SERVER + '/' + contentFolder + '/sitemap/sitemap-details.html').then((data) => (this.sitemapContent = data));
        },
        gotoTerms() {
            this.$router.push({
                path: '/terms',
            });
        },
        gotoPrivacy() {
            this.$router.push({
                path: '/privacy',
            });
        },
        gotoProducts() {
            let supplierRefId = this.$retrieveSupplierRefId();
            if (supplierRefId) {
                this.$router.push({
                    path: '/store/' + supplierRefId,
                });
            } else {
                this.$router.push({
                    path: '/',
                });
            }
        },
        gotoStoreInfo() {
            let supplierRefId = this.$retrieveSupplierRefId();
            if (supplierRefId) {
                this.$router.push({
                    path: '/contact/' + supplierRefId,
                });
            } else {
                this.$router.push({
                    path: '/',
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.footer-content {
    width: 1400px;
    margin-left: auto;
    margin-right: auto;
}

@media screen and (max-width: 1456px) {
    .footer-content {
        width: 100%;
        margin: auto;

        /*
        padding-top: 5px;    
        padding-bottom: 0px;*/
    }
}

@media screen and (min-width: 2500px) {
    .footer-content {
        width: 90%;
        margin: auto;
        margin-left: auto;
        margin-right: auto;
    }
}

@media screen and (min-width: 4250px) {
    .footer-content {
        width: 90%;
        margin: auto;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>
